"use strict";
/**
 * 전화번호·사업자번호·법인번호 — 서버(DTO Transform)와 화면(입력 포맷)이 **같은 규칙**으로 정리한다.
 *
 * 규칙은 하나다: **구분 기호만 걷어낸다.** 숫자가 아닌 것을 전부 지우면 `+82-10-1234-5678`이
 * `82101234567`(11자리)로 변해 서버 검증을 통과해 버리고, 상한으로 자르면 12자리 붙여넣기의
 * 마지막 자리가 조용히 사라진다(2026-09-15 리뷰 C1). 글자·`+`는 남겨 두어 형식 검사가 거절하게 한다.
 *
 * 화면은 정리한 값이 숫자만이고 길이가 맞을 때만 하이픈을 붙여 보여 주고, 아니면 정리한 값을
 * 그대로 보여 준다(저장하면 서버가 400을 준다).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CORP_NO_DIGITS = exports.BIZ_NO_DIGITS = exports.TEL_MESSAGE = exports.TEL_PATTERN = exports.TEL_MAX_DIGITS = exports.TEL_MIN_DIGITS = exports.NUMBER_SEPARATOR_RE = void 0;
exports.stripNumberSeparators = stripNumberSeparators;
/** 전화번호에서 걷어내는 구분 기호 — 공백·하이픈·괄호·마침표 */
exports.NUMBER_SEPARATOR_RE = /[\s\-().]/g;
/** 구분 기호만 제거한다. null·undefined는 그대로, 빈 문자열은 빈 문자열 */
function stripNumberSeparators(value) {
    if (value === null || value === undefined) {
        return value;
    }
    return value.replace(exports.NUMBER_SEPARATOR_RE, '');
}
/**
 * 전화번호 자릿수 범위 — 서버 `@Matches`와 화면 포맷 상한이 같은 값을 읽는다.
 * 8자리(15xx 대표번호)부터 12자리(050x 안전번호)까지. 국가번호가 붙은 값은 범위 밖이다.
 */
exports.TEL_MIN_DIGITS = 8;
exports.TEL_MAX_DIGITS = 12;
exports.TEL_PATTERN = new RegExp(`^\\d{${exports.TEL_MIN_DIGITS},${exports.TEL_MAX_DIGITS}}$`);
exports.TEL_MESSAGE = `연락처는 숫자 ${exports.TEL_MIN_DIGITS}~${exports.TEL_MAX_DIGITS}자리입니다.`;
exports.BIZ_NO_DIGITS = 10;
exports.CORP_NO_DIGITS = 13;
